module.exports = __webpack_public_path__ + "static/media/Mirage.21d23f41.jpeg";